import axiosInstance from "../instance";

// Get All Categories
const fetchPlatformFee = async () => {
    const response = await axiosInstance.get('/platformFee');
    return response.data;
}

const addPlatformFee = async (newPlatformFee) => {
    console.log('Add New Fee');
    console.log(newPlatformFee);
    const response = await axiosInstance.post('/platformFee', newPlatformFee);
    return response.data;
}

const updatePlatformFee = async (newPlatformFee) => {
    console.log('Updating Platform Fee');
    console.log(newPlatformFee);
    const response = await axiosInstance.put('/platformFee', newPlatformFee);
    return response.data;
}

const deletePlatformFee = async (platformFeeId) => {
    console.log('Deleting Platform Fee');
    console.log(platformFeeId);

    const response = await axiosInstance.delete('/platformFee', { params: { platformFeeId } });
}

export { fetchPlatformFee, addPlatformFee, updatePlatformFee, deletePlatformFee };